// feature-module/student/pages/tabs/StudentMarksTab.tsx
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Spin, Alert, Card } from "antd";
import { useSelector } from "react-redux";


import StudentSelectorWrapper from "../../../../components/Peoples/guardian/StudentSelectorWrapper";
import { useEffectiveStudentId } from "../../../../components/Peoples/guardian/hooks/useEffectiveStudentId";
import { useOutletContext } from "react-router-dom";
import { useStudentMarks } from "feature-module/academic/mark/hooks/useStudentMarks";
import StudentReport from "feature-module/academic/mark/components/StudentReport";
import Loader from "components/Common/loader";
import CustomAlert from "components/Common/ui/CustomAlert";

type Ctx = { student: any | null };

const StudentMarksTab: React.FC = () => {
    const { t } = useTranslation();
    const { student } = useOutletContext<Ctx>();
    const studentId = student?.id;

    const classId = useMemo(() => student?.class?.id, [student]);


    const { marksData, isLoading, error } = useStudentMarks(studentId);

    if (isLoading) return <Loader />


    return (
        <div className="p-2">


            {error ? (
                <CustomAlert
                    message={t("error_fetching_marks")}
                    type="error"
                    showIcon
                />
            ) : (
                <Card  className="mb-3">
                    {marksData ? (
                        <StudentReport marksData={marksData} />
                    ) : (
                        <CustomAlert
                            message={t("errors.no_marks_available.message")}
                            description={t("errors.no_marks_available.description")}
                            type="warning"
                            showIcon
                        />
                    )}
                </Card>
            )}

        </div >
    );
};

export default StudentMarksTab;
